import _ from "lodash"

export const getAnnouncementDetailTitle = announcement => _.get(announcement,['title'],"")
export const getAnnouncementDetailContent = announcement => _.get(announcement,['content'],"")
export const getAnnouncementDetailUpdatedAtText = announcement => _.get(announcement,['updated_at',"text"],"")
